import {
    contentTypeDataNewSite,
    contentTypeModelTypeNewSite,
} from './mo_content_type_new'
import {
    contentTypeDataOldSite,
    contentTypeModelTypeOldSite,
} from './mo_content_type_old'

// main
export type contentTypeModelTypeSite = contentTypeModelTypeNewSite | contentTypeModelTypeOldSite
export const contentTypeDataSite = {
    ...contentTypeDataNewSite,
    ...contentTypeDataOldSite,
}
